import React from "react";
import FeatureDocumentation from "../../components/layouts/docsection";


const DeliveryLocation = () => {
  const DeliveryLocationDoc = {
    title: "Delivery Location Management",
    description: "Learn how to manage delivery locations, including pricing and delivery options, to ensure efficient product delivery.",
    sections: [
      {
        title: "Overview",
        content: 
          "The Delivery Locations section helps manage the specific areas eligible for product delivery, along with the associated delivery costs. This feature ensures accurate delivery information and pricing for each location.",
      },
      {
        title: "Add Delivery Location",
        content: 
          "Use this feature to add new delivery locations and specify delivery costs.",
        subsections: [
          {
            title: "Steps to Create a New Delivery Location",
            content: "Follow these steps to set up a new delivery location and configure relevant details.",
            steps: [
              "Location: Enter the specific delivery area (e.g., Adenta, Madina, Makola). This helps customers identify if their area is covered.",
              "Price: Set the delivery cost for the specified location. Ensure the price aligns with the distance and delivery type.",
              "Type of Delivery: Choose the delivery type based on location and cost:\n - **Instant Delivery**: For areas that offer immediate delivery.\n - **Payment Before Delivery**: For locations requiring pre-payment. Confirm the appropriate type with a supervisor if uncertain.",
              "Remarks: Provide any additional notes about the delivery for customers, such as restrictions, expected delivery timeframes, or conditions specific to the location.",
            ],
          },
        ],
      },
    ],
  };
  
  return <FeatureDocumentation {...DeliveryLocationDoc} />;
};

export default DeliveryLocation;
